<template>
  <div class="settle-accounts-detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="baseFormRules"
            labelWidth="125px"
            @changeCompanyHandler="changeCompanyHandler"
            @changeDepartmentHandler="changeDepartmentHandler"
            @changeCurrencyHandler="changeCurrencyHandler"
            @changeSettlementDateHandler="changeSettlementDateHandler"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算行
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsRow
            ref="linesRef"
            @selectionRowHandler="selectionRowHandler"
            @closeEditTableHandler="closeRowEditTableHandler"
            @deleteTableHandler="deleteTableRowHandler"
            @deleteAllDetail="deleteAllDetailHandler"
            :baseFormData="baseFormData"
            :spaceList="spaceList"
            :isCreate="isCreate"
            :contractCategory="contractCategory"
            :currentDetailData="currentDetailData"
            :settleAccountsDetailMap="settleAccountsDetailMap"
            :linesData="detailData.lines ? detailData.lines : []"
            @importData="importDataHandler"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="currentSettleAccountRowData">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算明细
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsInfo
            ref="lineDetails"
            :isCreate="isCreate"
            @closeEditTableHandler="closeDetailEditTableHandler"
            :tableDataList="currentSettleAccountDetailList"
            :contractCategory="contractCategory"
            @deleteTableHandler="deleteTableDetailHandler"
            @saveDeleteLineDetailIds="saveDeleteLineDetailIds"
            :baseFormData="baseFormData"
            @importData="importDataHandler"
            :currentSettleAccountRowData="currentSettleAccountRowData"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4" v-if="deductions.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            抵扣信息
          </div>
        </template>
        <div class="collapse-content">
          <DeductionRow
            ref="DeductionRow"
            :isCreate="isCreate"
            :deductionList="deductions"
            @deleteDeductTableHandler="deleteDeductTableHandler"
            @closeEditDeductTableRowHandler="closeEditDeductTableRowHandler"
            @saveDeleteDeductionId="saveDeleteDeductionId"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5" v-if="billingInfoData.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            开票信息
          </div>
        </template>
        <div class="collapse-content">
          <BillingInfo :billingInfoData="billingInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="6" v-if="payeeInfoData.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            收款信息
          </div>
        </template>
        <div class="collapse-content">
          <PayeeInfo :payeeInfoData="payeeInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="7" v-if="detailApprovalRecords.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            审批信息
          </div>
        </template>
        <div class="collapse-content">
          <ApprovalTable :detailApprovalRecords="detailApprovalRecords" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="8">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="detailData.attachments"
            :isShowDownBtn="!isCreate"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 按钮组 -->
    <div class="btn-group">
      <el-button v-if="isCreate" type="primary" key="777" @click="_saveHandler()"> 保存 </el-button>
      <el-button v-if="isCreate" type="primary" key="888" @click="_saveHandler(1)">
        提交审批
      </el-button>
      <el-button v-if="isCreate" type="primary" key="999" @click="_btnDeductionHandler()">
        抵扣
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['01', '03', '05'].includes(this.statementStatus) &&
          !isCreate
        "
        type="primary"
        key="999"
        @click="isCreate = true"
      >
        编辑
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['06'].includes(this.statementStatus) &&
          billingInfoData.length < 1 &&
          !isCreate
        "
        type="primary"
        key="666"
        @click="isCreate = true"
      >
        调整
      </el-button>
      <el-button
        type="primary"
        v-for="(item, index) of btnList"
        :key="index"
        @click="btnClickHandler(item.type)"
        >{{ item.title }}</el-button
      >
      <el-button
        v-if="['02'].includes(this.statementStatus)"
        type="primary"
        key="10"
        @click="approvalreceivable({ type: 1 })"
      >
        审核通过
      </el-button>
      <el-button
        v-if="['02'].includes(this.statementStatus)"
        type="primary"
        key="11"
        @click="approvalreceivable({ type: 2 })"
      >
        审核驳回
      </el-button>
      <el-button v-if="this.statementStatus" type="primary" key="1" @click="closeTab()">
        返回
      </el-button>
    </div>
    <Print ref="easyPrint">
      <print-demo :content="content"></print-demo>
    </Print>
    <PrintDialog ref="PrintDialog" @printHandler="DetailprintHandler"></PrintDialog>
    <DeductionDialog
      ref="deductionDialogRef"
      @deductionDialogHandler="deductionDialogHandler"
    ></DeductionDialog>
    <!-- 批量开票前的弹窗 -->
    <InvoiceDialog
      ref="invoiceDialogRef"
      :extraOptions="extraOptions"
      @chooseInvoiceHandler="chooseInvoiceHandler"
    ></InvoiceDialog>
  </div>
</template>

<script>
  import { formatDate } from '@/utils';
  import DeductionDialog from './components/DeductionDialog/index.vue';
  import DeductionRow from './components/DeductionRow/index.vue';
  import SettleAccountsRow from './components/SettleAccountsRow/index.vue';
  import SettleAccountsInfo from './components/SettleAccountsInfo/index.vue';
  import BillingInfo from './components/BillingInfo/index.vue';
  import PayeeInfo from './components/PayeeInfo/index.vue';
  // import FileTable from './components/FileTable/index.vue';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import baseInfoMixin from './index.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import Print from '@/components/Print';
  import printDemo from '@/components/Print/printDemo';
  import PrintDialog from '../../../../components/PrintDialog.vue';
  import ApprovalTable from './components/approvalTable/Approval.vue';
  import InvoiceDialog from '@/pages/receivablesAndPayables/receivables/receivableStatementList/components/InvoiceDialog.vue';
  export default {
    name: 'parkPropertyReceivablesCreate',
    mixins: [baseInfoMixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
        baseFormData: {},
        content: '',
        currentSettleAccountRowData: null, // 当前选中的行数据
        settleAccountsRowList: [], // 全部的行数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,值为结算明细数组
        currentSettleAccountDetailList: [], //明细表数据
        currentStatus: '',
        currentDetailData: {}, // 当前结算明细数据
        statementStatus: '', // 结算单状态
        statementIssueStatus: '', // 开票状态
        deductions: [], //抵扣行信息
        deleteDeductionId: null, //删除的抵扣行id 编辑时用
        deductionDetails: [], //勾选的抵扣详细内容
        detailData: {}, // 根据id查询出来的数据
        billingInfoData: [], //根据结算单号查询出来的开票信息
        payeeInfoData: [], //根据结算单号查询出来的收款信息
        noLineDetails: false, //判断每个结算行至少要对应一个结算明细
        settlementIndex: '', //具体是哪个结算行没有结算明细
        deleteLineDetailIds: [],
        allDetailId: [],
        contractCategory: '', //合同类型
        detailApprovalRecords: [],
        extraOptions: [
          {
            value: '1',
            label: '数字化电子专票',
          },
          {
            value: '2',
            label: '数字化电子普票发票',
          },
        ],
      };
    },
    methods: {
      saveDeleteLineDetailIds(val) {
        this.deleteLineDetailIds = val;
      },
      //删除抵扣行
      deleteDeductTableHandler(deleteDeductionId) {
        console.log(this.deductions, 'this.deductions');
        this.$refs.lineDetails.changeTableRules(false);
        this.deleteDeductionId = deleteDeductionId || this.deleteDeductionId;
        const { deductionOriginalAmount, deductionDomesticAmount } = this.deductions[0];
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: (
            +this.baseFormData.originalTotalAmount + +deductionOriginalAmount
          ).toFixed(2),
          domesticTotalAmount: (
            +this.baseFormData.domesticTotalAmount + +deductionDomesticAmount
          ).toFixed(2),

          originalTotalAmountWithoutTax: (
            +this.baseFormData.originalTotalAmountWithoutTax + +deductionOriginalAmount
          ).toFixed(2),
          domesticTotalAmountWithoutTax: (
            +this.baseFormData.domesticTotalAmountWithoutTax + +deductionDomesticAmount
          ).toFixed(2),
        };
        this.deductions = [];
        this.deductionDetails = [];
      },
      //编辑抵扣行
      closeEditDeductTableRowHandler(value) {
        this.deductions = value;
      },
      saveDeleteDeductionId(val) {
        this.deleteDeductionId = val || this.deleteDeductionId;
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        console.log(rowData, 'rowData');
        this.currentSettleAccountRowData = rowData;
        //涉及到详情编辑的时候回显明细行
        if (rowData) {
          const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(rowData._XID);
          this.currentSettleAccountDetailList = currentSettleAccountDetailList
            ? currentSettleAccountDetailList
            : [];
        }
      },
      //抵扣按钮
      _btnDeductionHandler() {
        const { contractNo, originalTotalAmount } = this.baseFormData;
        this.$refs.deductionDialogRef.query.contractNo = contractNo;
        this.$refs.deductionDialogRef.outerOriginalTotalAmount = originalTotalAmount;

        this.$refs.deductionDialogRef.openDialog();
      },
      //抵扣弹窗关闭操作
      deductionDialogHandler(deductList, deductAll) {
        console.log('1111', this.$refs.lineDetails);
        console.log(this.$refs.lineDetails.$refs);
        if (deductList && deductList.length) {
          this.$refs.lineDetails.changeTableRules(true);
        } else {
          this.$refs.lineDetails.changeTableRules(false);
        }
        if (this.deductions && this.deductions.length) {
          this.deleteDeductionId = this.deductions[0]?.id || this.deleteDeductionId;
        }
        const {
          currencyCode,
          currencyName,
          exchangeRate,
          originalTotalAmount,
          domesticTotalAmount,

          originalTotalAmountWithoutTax,
          domesticTotalAmountWithoutTax,
        } = this.baseFormData;
        let deductTableData = this.$refs?.DeductionRow?.getTableData();
        if (deductTableData && deductTableData?.length) {
          const { deductionOriginalAmount, deductionDomesticAmount } = deductTableData[0];
          // 赋值给表单
          this.baseFormData = {
            ...this.baseFormData,
            originalTotalAmount:
              (+originalTotalAmount + +deductionOriginalAmount - deductAll).toFixed(2) + '',
            domesticTotalAmount:
              (+domesticTotalAmount + +deductionDomesticAmount - deductAll * exchangeRate).toFixed(
                2
              ) + '',

            originalTotalAmountWithoutTax:
              (+originalTotalAmountWithoutTax + +deductionOriginalAmount - deductAll).toFixed(2) +
              '',
            domesticTotalAmountWithoutTax:
              (
                +domesticTotalAmountWithoutTax +
                +deductionDomesticAmount -
                deductAll * exchangeRate
              ).toFixed(2) + '',
          };
        } else {
          // 赋值给表单
          this.baseFormData = {
            ...this.baseFormData,
            originalTotalAmount: (+originalTotalAmount - deductAll).toFixed(2) + '',
            domesticTotalAmount: (+domesticTotalAmount - deductAll * exchangeRate).toFixed(2) + '',

            originalTotalAmountWithoutTax:
              (+originalTotalAmountWithoutTax - deductAll).toFixed(2) + '',
            domesticTotalAmountWithoutTax:
              (+domesticTotalAmountWithoutTax - deductAll * exchangeRate).toFixed(2) + '',
          };
        }
        this.deductions = [
          {
            deductionDesc: '',
            deductionOriginalAmount: deductAll,
            currencyName,
            currencyCode,
            exchangeRate,
            deductionDomesticAmount: (deductAll * exchangeRate).toFixed(2),
          },
        ];
        this.deductionDetails = deductList;
      },
      // 关闭行编辑的时候
      closeRowEditTableHandler(tableData, isFetchData = false) {
        if (!tableData.length) return;
        this.settleAccountsRowList = tableData;
        // 计算原币结算金额和本币计算金额
        this._computeRowTableTotalAmount(tableData);
        if (isFetchData) {
          // 把当前表格里面的lineDetails设置到map中
          for (const item of tableData) {
            // 找到当前项的lineDetails
            let currentItem = this.detailData.lines.find((it) => it.idKey == item.idKey);
            const lineDetails = currentItem?.lineDetails ? currentItem?.lineDetails : [];
            if (!this.settleAccountsDetailMap.get(item._XID)) {
              this.settleAccountsDetailMap.set(item._XID, lineDetails);
            }
          }
        }
      },
      // 关闭明细表的时候
      closeDetailEditTableHandler(tableData) {
        console.log(tableData, '监听明细中');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, tableData);
        console.log(this.settleAccountsDetailMap, '明细中', this.currentSettleAccountRowData._XID);
        this.currentSettleAccountDetailList = tableData;
        this._computedDetailTableTotalAmount(tableData);
      },
      // 删除结算行
      deleteTableRowHandler(rowIdList, tableData) {
        console.log(rowIdList, '删除行', this.settleAccountsRowList);
        this.settleAccountsRowList = this.settleAccountsRowList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        // 计算金额
        this._computeRowTableTotalAmount(tableData);
      },
      // 结算行类型变化，删除结算明细
      deleteAllDetailHandler(lineId) {
        console.log(lineId);
        // this.settleAccountsRowList.forEach((item)=>{
        //   if(item.id==lineId){
        //     item.lineDetails=[];
        //   }
        // })
        // this.settleAccountsDetailMap.set(
        //   this.currentSettleAccountRowData._XID,
        //   []
        // );
        // const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(this.currentSettleAccountRowData._XID);
        //   this.currentSettleAccountDetailList = currentSettleAccountDetailList
        //     ? currentSettleAccountDetailList
        //     : [];
        // this.currentSettleAccountDetailList = currentSettleAccountDetailList;
        // this._computedDetailTableTotalAmount(this.currentSettleAccountDetailList);
      },
      // 导入明细表数据
      importDataHandler(importData) {
        console.log(importData, '导入明细表');
        const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
        // this.importData = data;
        const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        const detailData = importData.map((item) => {
          return {
            ...item,
            currencyCode: item.currencyCode || currencyCode,
            currencyName: item.currencyName || currencyName,
            exchangeRate: item.exchangeRate || exchangeRate,
            settlementQuantity: item.statementQuantity,
            unitName: item.unitName,
            originalAmountWithoutTax: (
              item.originalAmount /
              (1 + +(item.taxRate ? item.taxRate : 0))
            ).toFixed(2),
            originalTaxAmount: (
              item.originalAmount -
              item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))
            ).toFixed(2),
            domesticAmountWithoutTax: (
              (item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))) *
              item.exchangeRate
            ).toFixed(2),
            domesticTaxAmount: (
              item.domesticAmount -
              (item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))) * item.exchangeRate
            ).toFixed(2),
            // productCode:
            //   item.contractDetailInfo.contractMatter || item.contractDetailInfo.productNo,
            // productName:
            //   item.contractDetailInfo.contractMatterName || item.contractDetailInfo.productDesc,
          };
        });
        let newList = [];
        if (currentSettleAccountDetailList && currentSettleAccountDetailList?.length) {
          let ids = currentSettleAccountDetailList.map((item) => item.id);
          newList = detailData.filter((item) => !ids.includes(item.id));
        } else {
          newList = detailData;
        }
        this.currentSettleAccountDetailList = currentSettleAccountDetailList
          ? currentSettleAccountDetailList.concat(newList)
          : [].concat(newList);
        this.settleAccountsDetailMap.set(
          this.currentSettleAccountRowData._XID,
          this.currentSettleAccountDetailList
        );
        // this.currentSettleAccountDetailList = currentSettleAccountDetailList
        //   ? currentSettleAccountDetailList.concat(detailData)
        //   : [].concat(detailData);
        // this.settleAccountsDetailMap.set(
        //   this.currentSettleAccountRowData._XID,
        //   this.currentSettleAccountDetailList
        // );
        // 处理下反填到数据结算表中
        this._computedDetailTableTotalAmount(this.currentSettleAccountDetailList);
        // 处理好反填到表单上
        this._computeRowTableTotalAmount(this.settleAccountsRowList);
      },
      // 删除明细行
      deleteTableDetailHandler(rowIdList) {
        console.log(rowIdList, '删除明细', this.settleAccountsDetailMap);
        // 获取当当前数组项目
        const detailListItem = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        console.log(detailListItem, '删除前');
        // 删除子项
        let newData;
        if (detailListItem && detailListItem.length) {
          newData = detailListItem.filter((item) => !rowIdList.includes(item._XID));
        }
        this.currentSettleAccountDetailList = this.currentSettleAccountDetailList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        console.log(newData, '???删除后');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, newData);
        // 处理下反填到数据结算表中
        this._computedDetailTableTotalAmount(newData);
      },
      // 点击按钮组
      btnClickHandler(type) {
        if (type === 'save') {
          this._saveHandler();
        } else if (type === 'edit') {
          this.isCreate = true;
        } else if (type === 'approval') {
          this._saveHandler(1);
        } else if (type === 'billingApplication') {
          this._billingApplicationHandler();
        } else if (type === 'settlementLock') {
          this.lockHandler();
        } else if (type === 'resize') {
          this.isCreate = true;
        } else if (type === 'cancel') {
          this.withdrawHandler();
        } else if (type === 'close') {
          this.closeHandler();
        } else if (type === 'print') {
          this.printBtnClickHandler();
        }
        console.log(type, '点击按钮');
      },
      //审核
      async approvalreceivable({ type = 1 }) {
        const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_APPROVAL_API, {
          settlementNos: [this.$route.query?.receiveNo],
          type: type,
        });
        if (data.code === 0) {
          this.$message.success('操作成功');
          this.closeTab();
        } else {
          this.$message.error(`${data.msg}`);
        }
      },
      //打印
      printBtnClickHandler() {
        this.$refs.PrintDialog.openDialog();
        // this.loading.startLoading();
        // const params = {
        //   id: +this.$route.query?.id,
        //   downloadOrPrint: 'print',
        // };
        // this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
        //   if (res.data.code === 0) {
        //     this.loading.endLoading();
        //     if (res.data.data.pdf) {
        //       // window.location.href = res.data.data.pdf;
        //       window.open(res.data.data.pdf, '_blank');
        //     } else if (res.data.data.excel) {
        //       this.content = res.data.data.excel || '';
        //       setTimeout(() => {
        //         this.$refs.easyPrint.print();
        //       }, 500);
        //     }
        //   } else {
        //     this.loading.endLoading();
        //     this.$alert(res.data.msg);
        //   }
        // });
        // console.log('打印');
      },
      DetailprintHandler(val) {
        console.log(val);
        this.loading.startLoading();
        const params = {
          id: +this.$route.query?.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            this.loading.endLoading();
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          }
        });
      },
      //撤回
      async withdrawHandler() {
        this.$confirm('确定要撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_WITHDRAW_API, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('撤回成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //锁定
      async lockHandler() {
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_LOCK, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('锁定成功');
              this.$router.go(-1);
            } else if (data.code === 10000) {
              this.$message.error(`${data.msg}`);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //关闭
      async closeHandler() {
        this.$confirm('确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_CLOSE, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('关闭成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      // 获取开票前弹窗值
      chooseInvoiceHandler(value) {
        console.log('选择的值', value);
        this.invoiceHandler(Number(value));
      },
      //开票申请
      async _billingApplicationHandler() {
        // if (this.baseFormData.applyInvoiceAmount >= this.baseFormData.originalTotalAmount) {
        //   this.$message.error('申请开票金额 (开票申请总金额)不能大于或等于原币结算金额（含税）');
        //   return;
        // }
        // 打开弹窗
        this.$refs.invoiceDialogRef.openDialog();
      },
      async invoiceHandler(specialOrOrdinary) {
        let receivableSettlementIdList = [this.$route.query?.id];
        const postData = {
          receivableSettlementIdList,
          specialOrOrdinary,
        };

        // let postData = [28];
        // const { data } = await this.$axios.post(
        //   `${RECEIVABLES_TRADE.RECEIVABLE_BILLINGAPPLICATION_API}?businessGroup=${this.userInfo.businessGroup}`,
        //   postData
        // );
        // if (data.code == 0) {
        //   let path = {
        //     path: '/saleInvoice/add',
        //     name: 'saleInvoiceAdd',
        //     meta: {
        //       keepAlive: true,
        //       title: '创建销售开票',
        //     },
        //     query: { isEdit: 'Y', source: 'receive' },
        //     params: data.data,
        //   };
        //   this.$store.dispatch('tagsView/addTabView', path).then(() => {
        //     this.$nextTick(() => {
        //       this.$router.push(path);
        //     });
        //   });
        // } else {
        //   this.$message('开票申请失败');
        // }
        // 0512 开票 直接推送金蝶
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.RECEIVABLE_BATCH_INVOICE,
          postData
        );
        if (data.code == 0) {
          this.$message.success('开票成功！');
          this.closeTab();
        } else {
          if (data.msg) {
            return this.$message.error(data.msg);
          }
          this.$message.error('开票申请失败');
        }
      },
      //保存提交时计算明细行中所有的抵扣原币金额
      countLineDetaisDeductAll() {
        let lineDetailsDeductALL = 0;
        for (let mapData of this.settleAccountsDetailMap.values()) {
          for (const item of mapData) {
            lineDetailsDeductALL += +item['deductionOriginalAmount'];
          }
        }
        return lineDetailsDeductALL.toFixed(2);
      },
      // 保存接口 type 保存类型: 0-保存, 1-提交
      _saveHandler(type = 0) {
        console.log(this._formatSettleAccountDto(), '表格提交数据', this.settleAccountsDetailMap);
        console.log(this.$refs.linesRef.deleteLineIds, 'deleteLineIds');
        // 1.获取到基本信息数据
        this.$refs.baseInfoFormRef.validate(async (valid, baseInfoData) => {
          this.noLineDetails = false; //判断每个结算行至少要对应一个结算明细
          this.settlementIndex = '';
          if (!valid) {
            this.$message.error('请检查填写信息');
            return;
          }
          let checkLinesRefStatus = await this.$refs?.linesRef?.validAllEvent();
          if (checkLinesRefStatus) {
            return;
          }
          let checkLineDetailsStatus = await this.$refs?.lineDetails?.validAllEvent();
          if (checkLineDetailsStatus) {
            return;
          }

          let checkDeductionRowStatus = await this.$refs?.DeductionRow?.validAllEvent();
          if (checkDeductionRowStatus) {
            return;
          }

          //校验明细行中合计的抵扣金额原币（含税）是否与抵扣信息中抵扣金额原币（含税）一致
          if (
            this.countLineDetaisDeductAll() > 0 &&
            this.deductions[0]?.deductionOriginalAmount != this.countLineDetaisDeductAll()
          ) {
            this.$message.error(
              '明细行中合计的抵扣金额原币（含税）需与抵扣信息中抵扣金额原币（含税）一致'
            );
            return;
          }

          //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
          if (this.checkFalse()) {
            this.$message.error('结算行中原币结算单价（含税）和结算数量为必填项');
            return;
          }
          if (this._formatSettleAccountDto().length < 1) {
            this.$message.error('结算行不能为空！');
            return;
          }
          //判断每个结算行至少要对应一个结算明细
          if (this.noLineDetails) {
            this.$message.error(`请填写第${this.settlementIndex}行结算行的结算明细`);
            return;
          }
          //抵扣信息
          let deductions = this.deductions;
          //删除的抵扣行id 编辑时用
          let deleteDeductionId = this.deleteDeductionId;
          //勾选的抵扣详细内容
          let deductionDetails = this.deductionDetails;

          this.loading.startLoading();
          // 上传文件表格
          const fileTable = this.$refs.fileTableRef.getTableData();
          //删除的行ids
          const deleteLineIds = this.$refs?.linesRef.deleteLineIds
            ? this.$refs?.linesRef.deleteLineIds
            : [];
          //删除的明细表ids
          let deleteDetailId = [];
          this.settleAccountsRowList.forEach((line) => {
            if (line.lineDetails != null && line.lineDetails != []) {
              deleteDetailId.push(...line.lineDetails?.map((item) => item.id));
              console.log(line.lineDetails.map((item) => item.id));
            }
          });
          console.log('还有的明细行ID', deleteDetailId, this.allDetailId);
          let deleteLineDetailIds = this.allDetailId.filter(
            (item) => !deleteDetailId.includes(item)
          );
          console.log('删除的ID', deleteLineDetailIds);
          // this.$refs?.lineDetails?.deleteLineDetailIds.length > 0
          //   ? this.$refs?.lineDetails?.deleteLineDetailIds
          //   : this.deleteLineDetailIds;
          let postData = {
            ...baseInfoData,
            type,
            businessGroup: JSON.parse(localStorage.getItem('userInfo')).userInfo.businessGroup,
            oaId: JSON.parse(localStorage.getItem('userInfo')).userInfo.oaId,
            companyName: JSON.parse(localStorage.getItem('userInfo')).userInfo.companyName,
            printFlag: baseInfoData.printFlag && baseInfoData.printFlag == '1' ? 1 : 0,
            lines: this._formatSettleAccountDto(),
            attachments: fileTable,
            deleteLineIds,
            deleteLineDetailIds,
            deductions,
            deleteDeductionId,
            deductionDetails,
          };
          if (['edit', 'detail'].includes(this.$route.query?.status)) {
            postData.id = this.$route.query?.id;
          }
          const { data } = await this.$axios.post(
            RECEIVABLES_TRADE.CREATE_OR_EDIT_TRADE_RECEIVABLES_API,
            postData
          );

          console.log(data, '保存结果');
          if (data.code === 0) {
            this.loading.endLoading();
            this.$message.success(data.msg);
            // this.$router.go(-1);
            this.closeTab();
          } else {
            this.loading.endLoading();
            this.$message.error(data.msg);
          }
        });
      },
      closeTab() {
        // 关闭当前tab导航
        this.$store.dispatch('tagsView/delView', {
          path: '/receivablesAndPayables/parkPropertyReceivablesCreate',
          name: 'parkPropertyReceivablesCreate',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push({ path: '/receivablesAndPayables/receivablesList' });
      },
      //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
      checkFalse() {
        let lines = this._formatSettleAccountDto();
        let checkStatus = false;
        if (lines && lines.length) {
          for (let index = 0; index < lines.length; index++) {
            const item = lines[index];
            console.log(item);
            if (!item.lineDetails?.length && !item.originalPrice && !item.settlementQuantity) {
              checkStatus = true;
              break;
            }
          }
        }
        if (checkStatus) {
          return true;
        }
      },
      // 组装结算行结算明细数据给后端
      _formatSettleAccountDto() {
        const settleAccountList = [];
        this.settleAccountsRowList.map((item, index) => {
          const lineDetails = this.settleAccountsDetailMap.get(item._XID);
          if (!(lineDetails && lineDetails.length)) {
            this.noLineDetails = true; //判断每个结算行至少要对应一个结算明细
            this.settlementIndex = +index + 1;
          }
          settleAccountList.push({
            ...item,
            additional: item.additional ? 1 : 2,
            lineDetails: lineDetails ? lineDetails : [],
          });
        });
        return settleAccountList;
      },
      // 计算原币金额和本币金额到表单中
      _computeRowTableTotalAmount(tableData) {
        let originalTotalAmount = 0;
        let domesticTotalAmount = 0;
        let originalTotalAmountWithoutTax = 0;
        let originalTotalTaxAmount = 0;
        let domesticTotalAmountWithoutTax = 0;
        let domesticTotalTaxAmount = 0;
        for (const item of tableData) {
          originalTotalAmount += +item['originalAmount'];
          domesticTotalAmount += +item['domesticAmount'];

          originalTotalAmountWithoutTax += +item['originalAmountWithoutTax'];
          originalTotalTaxAmount += +item['originalTaxAmount'];
          domesticTotalAmountWithoutTax += +item['domesticAmountWithoutTax'];
          domesticTotalTaxAmount += +item['domesticTaxAmount'];
        }
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: originalTotalAmount ? originalTotalAmount.toFixed(2) + '' : '0',
          domesticTotalAmount: domesticTotalAmount ? domesticTotalAmount.toFixed(2) + '' : '0',
          originalTotalAmountWithoutTax: originalTotalAmountWithoutTax.toFixed(2) + '',
          originalTotalTaxAmount: originalTotalTaxAmount.toFixed(2) + '',
          domesticTotalAmountWithoutTax: domesticTotalAmountWithoutTax.toFixed(2) + '',
          domesticTotalTaxAmount: domesticTotalTaxAmount.toFixed(2) + '',
        };
      },
      // 计算明细表中的原币金额和本币金额反填到结算表中
      _computedDetailTableTotalAmount(tableData, isNew = false) {
        if (tableData && tableData.length) {
          let domesticAmount = 0;
          let originalAmount = 0;
          let originalAmountWithoutTax = 0;
          let originalTaxAmount = 0;
          let domesticAmountWithoutTax = 0;
          let domesticTaxAmount = 0;
          let settlementQuantityTotal = 0; // 结算数量
          for (const item of tableData) {
            originalAmount += +item['originalAmount'];
            domesticAmount += +item['domesticAmount'];
            settlementQuantityTotal += +item['settlementQuantity'];
            originalAmountWithoutTax += +item['originalAmountWithoutTax'];
            originalTaxAmount += +item['originalTaxAmount'];
            domesticAmountWithoutTax += +item['domesticAmountWithoutTax'];
            domesticTaxAmount += +item['domesticTaxAmount'];
          }
          const originalPriceList = tableData.map((item) => item.originalPrice);
          const originalPrice =
            [...new Set(originalPriceList)].length > 1 ? '' : originalPriceList[0];
          const settlementQuantity =
            [...new Set(originalPriceList)].length > 1 ? '' : settlementQuantityTotal.toFixed(2);
          const unitList = tableData.map((item) => item.unit);
          const unit = [...new Set(unitList)].length > 1 ? '' : unitList[0]; // 单位
          const unitNameList = tableData.map((item) => item.unitName);
          const unitName = [...new Set(unitNameList)].length > 1 ? '' : unitNameList[0]; // 单位

          console.log(originalPrice, unit, unitName, settlementQuantity, '11111111---->>');
          // 给第一个表格赋值
          this.currentDetailData = {
            domesticAmount: domesticAmount.toFixed(2) + '',
            spaceAssetName: tableData[0].spaceAssetName,
            originalAmount: originalAmount.toFixed(2) + '',
            originalPrice,
            settlementQuantity,
            unit,
            unitName,
            originalAmountWithoutTax: originalAmountWithoutTax.toFixed(2) + '',
            originalTaxAmount: originalTaxAmount.toFixed(2) + '',
            domesticAmountWithoutTax: domesticAmountWithoutTax.toFixed(2) + '',
            domesticTaxAmount: domesticTaxAmount.toFixed(2) + '',
            _XID: isNew ? null : this.currentSettleAccountRowData._XID, // 当前行
          };
        } else {
          // 给第一个表格赋值
          this.currentDetailData = {
            domesticAmount: '0',
            originalAmount: '0',
            originalPrice: '0',
            settlementQuantity: '',
            spaceAssetName: '',
            originalAmountWithoutTax: '0',
            originalTaxAmount: '0',
            domesticAmountWithoutTax: '0',
            domesticTaxAmount: '0',
            _XID: this.currentSettleAccountRowData._XID, // 当前行
          };
        }
      },
      // 根据id来查下数据
      async _getDetailDataById(id) {
        if (!id) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          `${RECEIVABLES_TRADE.GET_RECEIVABLE_SETTLEMENT_DETAIL_BY_ID}/${id}`
        );
        console.log(data, 'data');
        if (data.code == 0) {
          this.loading.endLoading();
          this.detailData = data.data;
          this.detailData.lines.forEach((line) => {
            line.idKey = line.id;
            this.allDetailId.push(...line.lineDetails.map((item) => item.id));
          });
          // 单独抽取表单数据
          const {
            settlementCompanyNo,
            settlementCompanyName,
            settlementDepartmentNo,
            settlementDepartmentName,
            customerName,
            customerNo,
            receivableSettlementNo,
            settlementDate,
            leaseDateFrom,
            leaseDateUntil,
            // projectInitiationNo,
            projectName,
            contractNo,
            domesticTotalAmount,
            settlementType,
            currencyCode,
            currencyName,
            exchangeDate,
            exchangeRate,
            settlementStatus,
            settlementIssueStatus,
            invoiceAmount,
            collectedAmount,
            salesmanNo,
            salesmanName,
            weaveNo,
            weaveName,
            settlementCreateDate,
            originalTotalAmount,
            applyInvoiceAmount,
            receivableAccountPeriod,
            receiveStatus,
            printFlag,
            remark,
          } = data.data;
          this.baseFormData = {
            settlementCompanyNo, //公司名称
            settlementCompanyName,
            settlementDepartmentNo, //部门
            settlementDepartmentName,
            customerName, //customerName
            customerNo,
            receivableSettlementNo,
            settlementDate, //结算日期
            projectName,
            contractNo, //合同编号
            domesticTotalAmount: domesticTotalAmount ? domesticTotalAmount + '' : '0', //本币结算总金额（含税）
            settlementType, //结算类型
            currencyCode, //币种
            currencyName,
            exchangeDate, //汇率
            exchangeRate: exchangeRate ? exchangeRate + '' : '1', //汇率日期
            settlementStatus, //结算单状态
            settlementIssueStatus, //开票状态
            invoiceAmount: invoiceAmount ? invoiceAmount + '' : '0', //开票金额
            collectedAmount: collectedAmount ? collectedAmount + '' : '0', //已收款金额
            leaseDate:
              leaseDateFrom && leaseDateUntil
                ? `${(leaseDateFrom || '').replaceAll('-', '.')}-${(
                    leaseDateUntil || ''
                  ).replaceAll('-', '.')}`
                : '',
            salesmanNo,
            salesmanName, //业务人员
            weaveNo,
            weaveName,
            settlementCreateDate, //创建日期
            originalTotalAmount: originalTotalAmount ? originalTotalAmount + '' : '0', //原币结算总金额（含税）
            settlementBusinessType: '04', //
            applyInvoiceAmount: applyInvoiceAmount ? applyInvoiceAmount.toFixed(2) : '',
            receivableAccountPeriod,
            receiveStatus, //收款状态
            printFlag: printFlag === 0 ? '0' : '1', //是否已打印
            remark,
          };
          this.statementStatus = settlementStatus; //结算单状态
          this.statementIssueStatus = settlementIssueStatus; //开票状态
          //抵扣信息
          this.deductions = data.data.deductions || [];
          this.detailApprovalRecords = data.data.records || []; //审批信息
          // 反填部门信息
          this._getDepartmentByCompanyCodeApi(settlementCompanyNo);
          this.getAllSpaceInfoByContract(contractNo);
          this.getContractDetail(contractNo);
          this._getInvoiceTablelistData(this.$route.query?.receiveNo);
          this._getCollectTablelistData(this.$route.query?.receiveNo);
        } else {
          this.$message.error('获取数据失败');
        }
      },
      //费用清单跳转过来创建结算单
      async _getBaseformData(ids) {
        if (ids.length < 1) return;
        this.loading.startLoading();
        const postData = { ids };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_BASEFORMDATA_BY_IDS,
          postData
        );
        console.log(data, '基本信息');
        if (data.code == 0) {
          this.loading.endLoading();
          // 单独抽取表单数据
          const {
            businessCompanyNo,
            businessCompanyName,
            businessDepartmentCode,
            businessDepartmentName,
            customerName,
            customerNo,
            settlementNo,
            projectName,
            contractNo,
            leaseDateFrom,
            leaseDateUntil,
            domesticAmount,
            currencyCode,
            currencyName,
            // exchangeDate,
            exchangeRate,
            settlementStatus,
            // settlementIssueStatus,
            invoiceAmount,
            collectedAmount,
            gmtCreate,
            originalAmount,
            accountPeriod,
            receiveStatus,
            businessCategory,
            remark,
          } = data.data[0];
          this.baseFormData = {
            settlementCompanyNo: businessCompanyNo,
            settlementCompanyName: businessCompanyName,
            settlementDepartmentNo: businessDepartmentCode,
            settlementDepartmentName: businessDepartmentName,
            businessCategory: businessCategory, //业务类别
            customerName,
            customerNo,
            receivableSettlementNo: settlementNo,
            settlementDate: formatDate(new Date()),
            projectName,
            contractNo,
            domesticTotalAmount: domesticAmount ? domesticAmount + '' : '0',
            leaseDate:
              leaseDateFrom && leaseDateUntil
                ? `${(leaseDateFrom || '').replaceAll('-', '.')}-${(
                    leaseDateUntil || ''
                  ).replaceAll('-', '.')}`
                : '',
            settlementType: '2',
            currencyCode,
            currencyName,
            exchangeDate: formatDate(new Date()),
            exchangeRate: exchangeRate ? exchangeRate + '' : '1',
            settlementStatus,
            settlementIssueStatus: '02',
            invoiceAmount: invoiceAmount ? invoiceAmount + '' : '0',
            collectedAmount: collectedAmount ? collectedAmount + '' : '0',
            salesmanNo: this.userInfo.personNo,
            salesmanName: this.userInfo.personName,
            settlementCreateDate: gmtCreate,
            originalTotalAmount: originalAmount ? originalAmount + '' : '0',
            settlementBusinessType: '04',
            receivableAccountPeriod: accountPeriod,
            receiveStatus,
            printFlag: false,
            remark,
          };
          // 反填部门信息
          this._getDepartmentByCompanyCodeApi(businessCompanyNo);
          this.getAllSpaceInfoByContract(contractNo);
          this.getContractDetail(contractNo, data.data);
          //根据公司部门下的合同获取商品
          // this._getContractProduct(businessCompanyNo, businessDepartmentCode, contractNo);
          console.log(data, '基本信息');
        }
      },
      // 开票信息
      async _getInvoiceTablelistData(receiveNo) {
        if (!receiveNo) return;
        const postData = { receivableSettlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_INVOICING_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.billingInfoData = data.data || [];
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '开票信息');
      },
      // 收款信息
      async _getCollectTablelistData(receiveNo) {
        if (!receiveNo) return;
        const postData = { settlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_COLLECTION_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.payeeInfoData = data.data || [];
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '收款信息');
      },

      //将行明细组装成行信息
      assembleHandler(tableData, contractCategory) {
        if (!tableData) {
          return;
        }
        let originalTotalAmountWithoutTax = 0;
        let originalTotalTaxAmount = 0;
        let domesticTotalAmountWithoutTax = 0;
        let domesticTotalTaxAmount = 0;
        tableData.forEach((item) => {
          item.settlementQuantity = item.statementQuantity;
          item.exchangeRate = item.exchangeRate || 1;
          item.taxRate = item.taxRate || '0.00';
          item.businessDocNo = item.businessDocCode;
          item.originalAmount = item.originalAmount.toFixed(2);
          item.domesticAmount = item.domesticAmount.toFixed(2);
          item.originalAmountWithoutTax = (
            item.originalAmount /
            (1 + +(item.taxRate ? item.taxRate : 0))
          ).toFixed(2);
          item.originalTaxAmount = (item.originalAmount - item.originalAmountWithoutTax).toFixed(2);
          item.domesticAmountWithoutTax = (
            item.domesticAmount /
            (1 + +(item.taxRate ? item.taxRate : 0))
          ).toFixed(2);
          item.domesticTaxAmount = (item.domesticAmount - item.domesticAmountWithoutTax).toFixed(2);
        });
        let domesticAmount = 0;
        let originalAmount = 0;
        for (const item of tableData) {
          originalAmount += +item['originalAmount'];
          domesticAmount += +item['domesticAmount'];
          originalTotalAmountWithoutTax += +item['originalAmountWithoutTax'];
          originalTotalTaxAmount += +item['originalTaxAmount'];
          domesticTotalAmountWithoutTax += +item['domesticAmountWithoutTax'];
          domesticTotalTaxAmount += +item['domesticTaxAmount'];
        }

        let dataMap = this.classificationHandler(tableData, contractCategory);
        console.log(dataMap, 'dataMapdataMapdataMap');
        let lines = [];
        for (const key in dataMap) {
          const currentItemList = dataMap[key].item; // 同一类供应商
          const currentUnit = [...new Set(currentItemList.map((it) => it.unit))];
          const currentUnitName = [...new Set(currentItemList.map((it) => it.unitName))];
          const unit = currentUnit.length > 1 ? '' : currentUnit[0]; // 单位
          const unitName = currentUnitName.length > 1 ? '' : currentUnitName[0]; // 单位名称
          const originalPriceList = [...new Set(currentItemList.map((it) => it.originalPrice))];
          let domesticAmount = 0;
          let originalAmount = 0;
          let settlementQuantityTotal = 0; // 数量
          for (const item of currentItemList) {
            originalAmount += +item['originalAmount'];
            domesticAmount += +item['domesticAmount'];
            settlementQuantityTotal += +item['statementQuantity'];
          }
          let settlementQuantity = originalPriceList.length > 1 ? '' : settlementQuantityTotal;

          let businessDocNoList = [...new Set(currentItemList.map((it) => it.businessDocNo))];
          let businessDocNo = businessDocNoList.length > 1 ? '' : businessDocNoList[0];

          lines.push({
            settlementDesc: '',
            originalPrice: originalPriceList.length > 1 ? '' : originalPriceList[0],
            settlementQuantity,
            originalAmount: originalAmount.toFixed(2),
            currencyCode: currentItemList[0].currencyCode,
            currencyName: currentItemList[0].currencyName,
            contractNo: currentItemList[0].contractNo,
            spaceAssetName: currentItemList[0].spaceAssetName,
            spaceAssetId: currentItemList[0].spaceAssetId,
            exchangeRate: currentItemList[0].exchangeRate ? currentItemList[0].exchangeRate : 1,
            domesticAmount: domesticAmount.toFixed(2),
            additional: '',
            businessDocNo,
            unit,
            unitName,
            productType: currentItemList[0].productType,
            productTypeName: currentItemList[0].productTypeName,
            serviceType: currentItemList[0].serviceType,
            serviceTypeName: currentItemList[0].serviceTypeName,
            expenseType: currentItemList[0].expenseType,
            expenseTypeName: currentItemList[0].expenseTypeName,
            originalAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.originalAmountWithoutTax, 0)
              .toFixed(2),
            originalTaxAmount: currentItemList
              .reduce((pre, next) => pre + +next.originalTaxAmount, 0)
              .toFixed(2),
            domesticAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.domesticAmountWithoutTax, 0)
              .toFixed(2),
            domesticTaxAmount: currentItemList
              .reduce((pre, next) => pre + +next.domesticTaxAmount, 0)
              .toFixed(2),
            remark: '',
            idKey: currentItemList[0].id,
            lineDetails: currentItemList,
          });
        }
        this.detailData = { lines };
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: originalAmount.toFixed(2) + '',
          domesticTotalAmount: domesticAmount.toFixed(2) + '',
          originalTotalAmountWithoutTax: originalTotalAmountWithoutTax.toFixed(2),
          originalTotalTaxAmount: originalTotalTaxAmount.toFixed(2),
          domesticTotalAmountWithoutTax: domesticTotalAmountWithoutTax.toFixed(2),
          domesticTotalTaxAmount: domesticTotalTaxAmount.toFixed(2),
        };
      },

      classificationHandler(arr, contractCategory) {
        let map = [
          {
            expenseType: arr[0].expenseType,
            spaceAssetId: arr[0].spaceAssetId,
            item: [arr[0]],
          },
        ];
        if (contractCategory == '01') {
          for (let i = 1; i < arr.length; i++) {
            let bool = map.some((it) => {
              if (arr[i].expenseType == it.expenseType) {
                if (arr[i].spaceAssetId == it.spaceAssetId) {
                  it['item'].push(arr[i]);
                }
                return arr[i].spaceAssetId == it.spaceAssetId;
              } else {
                return arr[i].expenseType == it.expenseType;
              }
            });
            if (!bool) {
              map.push({
                expenseType: arr[i].expenseType,
                spaceAssetId: arr[i].spaceAssetId,
                item: [arr[i]],
              });
            }
          }
        } else {
          for (let i = 1; i < arr.length; i++) {
            let bool = map.some((it) => {
              if (arr[i].expenseType == it.expenseType) {
                it['item'].push(arr[i]);
              }
              return arr[i].expenseType == it.expenseType;
            });
            if (!bool) {
              map.push({
                expenseType: arr[i].expenseType,
                item: [arr[i]],
              });
            }
          }
        }

        for (const it of map) {
          console.log(it, 'of循环map');
        }
        for (const it in map) {
          console.log(map[it].item, 'in循环map');
        }
        console.log(map, '分类处理');
        return map;
      },
    },
    mounted() {
      this.currentStatus = this.$route.query?.status; // 当前状态
      if (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0) {
        let ids = this.$route.query?.id;
        if (ids && Array.isArray(ids) && ids.length) {
          this._getBaseformData(ids);
        } else {
          this._getBaseformData([ids]);
        }
      }
      if (['detail', 'edit'].includes(this.$route.query?.status)) {
        this._getDetailDataById(this.$route.query?.id);
        // this._getInvoiceTablelistData(this.$route.query?.receiveNo);
        // this._getCollectTablelistData(this.$route.query?.receiveNo);
      }
    },
    computed: {
      btnList() {
        const allBtnList = [
          {
            title: '保存',
            type: 'save',
          },
          {
            title: '编辑',
            type: 'edit',
          },
          {
            title: '提交审批',
            type: 'approval',
          },
          {
            title: '开票申请',
            type: 'billingApplication',
          },
          {
            title: '结算锁定',
            type: 'settlementLock',
          },
          {
            title: '调整',
            type: 'resize',
          },
          {
            title: '撤回',
            type: 'cancel',
          },
          {
            title: '关闭',
            type: 'close',
          },
          {
            title: '打印',
            type: 'print',
          },
        ];
        // statementStatus:01-保存,02-审批中,03-已驳回,04-已通过,05-已撤回,06-已锁定,07-已关闭
        // statementIssueStatus  01-已开票,02-未开票,03-部分开票
        // billingInfoData  是否关联开票申请单   当billingInfoData.length>0就关联了 否则未关联
        // if (['create'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save'].includes(item.type));
        // }
        // if (['edit'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save', 'approval'].includes(item.type));
        // }
        if (['detail'].includes(this.currentStatus)) {
          // if (['01', '03', '05'].includes(this.statementStatus)) {
          //   // 已经保存,已驳回,已撤回
          //   return allBtnList.filter((item) => ['edit'].includes(item.type));
          // } else
          if (['04'].includes(this.statementStatus)) {
            if (this.billingInfoData.length < 1) {
              return allBtnList.filter((item) =>
                ['billingApplication', 'settlementLock', 'cancel', 'print'].includes(item.type)
              );
            } else if (
              this.billingInfoData.length > 0 &&
              ['02', '03'].includes(this.statementIssueStatus)
            ) {
              return allBtnList.filter((item) =>
                ['billingApplication', 'print'].includes(item.type)
              );
            } else if (
              this.billingInfoData.length > 0 &&
              ['01'].includes(this.statementIssueStatus)
            ) {
              return allBtnList.filter((item) => ['close', 'print'].includes(item.type));
            } else {
              return [];
            }
          }
          //  else if (['06'].includes(this.statementStatus) && this.billingInfoData.length < 1) {
          //   return allBtnList.filter((item) => ['resize'].includes(item.type));
          // }
          else {
            return [];
          }
        } else {
          return [];
        }
        // return allBtnList;
      },
      // 是否隐藏开票和收款信息
      isHiddenInfo() {
        return ['edit', 'detail'].includes(this.currentStatus);
      },
    },
    components: {
      // BaseInfo,
      SettleAccountsRow,
      SettleAccountsInfo,
      BillingInfo,
      PayeeInfo,
      DeductionDialog,
      DeductionRow,
      // FileTable,
      SiruiSearch,
      Print,
      printDemo,
      PrintDialog,
      ApprovalTable,
      InvoiceDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
</style>
